import { Component, EventEmitter, inject, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { CartItemOptions, CartItem } from '../../../model/cart-item';
import { CartItemStateService } from '../../../services/cart-item-state.service';
import { BtAlertComponent } from '../../ui/bt-alert/bt-alert.component';
import { LibModulesWolcModule } from '../../lib-modules-wolc.module';
import { BtOrderAccessoriesComponent } from '../order-accessories/order-accessories.component';
import { BtOrderAmountSummaryComponent } from '../order-amount-summary/order-amount-summary.component';
import { BtOrderGroupItemsComponent } from '../order-group-items/order-group-items.component';
import { BtOrderInputFieldsComponent } from '../order-input-fields/order-input-fields.component';
import { BtOrderPackageItemsComponent } from '../order-package-items/order-package-items.component';
import { BtOrderPeriodGuestsComponent } from '../order-period-guests/order-period-guests.component';
import { BtOrderPoolUnitsComponent } from '../order-pool-units/order-pool-units.component';

@Component({
  selector: 'btlib-order-product-form',
  standalone: true,
  imports: [
    LibModulesWolcModule,
    BtAlertComponent,
    BtOrderPeriodGuestsComponent,
    BtOrderPoolUnitsComponent,
    BtOrderAccessoriesComponent,
    BtOrderGroupItemsComponent,
    BtOrderPackageItemsComponent,
    BtOrderInputFieldsComponent,
    BtOrderAmountSummaryComponent
  ],
  providers: [CartItemStateService],
  templateUrl: './order-product-form.component.html',
  styleUrl: './order-product-form.component.scss'
})
export class BtOrderProductFormComponent implements OnInit {
  state = inject(CartItemStateService);

  @Input({ required: true }) productId!: number;
  @Input() cid: string = '';
  @Input() options: CartItemOptions = {};
  @Output() change = new EventEmitter<CartItem>();
  @Output() submit = new EventEmitter<{ cartItem: CartItem; action: 'addToCart' | 'checkout' }>();

  @ViewChildren(BtOrderInputFieldsComponent) inputFieldsComponents!: QueryList<BtOrderInputFieldsComponent>;

  async ngOnInit(): Promise<void> {
    await this.state.init(this.productId, this.cid, this.options);
  }

  addToCart(): void {
    this.emitSubmit('addToCart');
  }

  checkout(): void {
    this.emitSubmit('checkout');
  }

  private emitSubmit(action: 'addToCart' | 'checkout'): void {
    // Validate all input-fields forms (main product + accessories with inputs)
    let valid = true;
    for (const comp of this.inputFieldsComponents) {
      if (!comp.markAllTouched()) {
        valid = false;
      }
    }
    if (!valid) return;

    try {
      const cartItem = this.state.buildCartItem();
      this.submit.emit({ cartItem, action });
      this.change.emit(cartItem);
    } catch (e: any) {
      // Form is not ready; do nothing.
    }
  }
}
